import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getCurrentDate } from "../../Utilitie";
import axios from "axios";
import NoDataFound from "../../Extra/NoDataFound";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";

const PathWastageUpdate = ({ stations, machineData, filteredReason }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [resultMsg, setResultMsg] = useState(false);
  const [show, setShow] = useState(false);

  const [selectedDate, setSelectedDate] = useState(getCurrentDate());
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const keys = [
    "PT_TYPE",
    "PT_FROM",
    "PT_TO",
    "PT_REASON",
    "PT_WASTAGE_NUM",
    "PT_WASTAGE_TRAIN_TYPE",
    "REMARK",
  ];
  const options = {
    PT_TYPE: machineData,
    PT_FROM: [...new Set(stations.map((e) => e.station_code))],
    PT_TO: [...new Set(stations.map((e) => e.station_code))],
    PT_REASON: [...filteredReason.map((o) => o.table_option_for_insertion)],
    PT_WASTAGE_TRAIN_TYPE: [
      "Goods Train",
      "Passenger Train",
      "Mail/Exp Train",
      "Superfast Train",
    ],
  };

  useEffect(() => {
    if (data.length > 0) {
      setRows(data);
    }
  }, [data]);

  const getEmptyRow = () => ({
    PT_DATE: "",
    PT_TYPE: "",
    PT_FROM: "",
    PT_TO: "",
    PT_REASON: "",
    PT_WASTAGE_NUM: "",
    PT_WASTAGE_TRAIN_TYPE: "",
    REMARK: "",
  });
  const [rows, setRows] = useState([getEmptyRow()]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${urlBlockPrefix}getPathData?start=${selectedDate}&end=${selectedDate}`,
      );
      if (response.data.status === "ok") {
        setData(response.data.daterange.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedDate]);

  const [dropdownStates, setDropdownStates] = useState([
    {
      ptTypeDropdownOpen: false,
      ptFromDropdownOpen: false,
      ptToDropdownOpen: false,
      searchQuery: "",
      toStation: "",
      fromStation: "",
    },
  ]);

  useEffect(() => {
    if (dropdownStates.length !== rows.length) {
      const newDropdownStates = [...dropdownStates];
      while (newDropdownStates.length < rows.length) {
        newDropdownStates.push({
          ptTypeDropdownOpen: false,
          ptFromDropdownOpen: false,
          ptToDropdownOpen: false,
          searchQuery: "",
          toStation: "",
          fromStation: "",
        });
      }
      setDropdownStates(newDropdownStates);
    }
  }, [rows]);

  const handleChange = (rowIndex, key, value) => {
    setRows((prevRows) =>
      prevRows.map((row, i) =>
        i === rowIndex ? { ...row, [key]: value } : row,
      ),
    );
  };

  const toggleCheckbox = (rowIndex, key, value) => {
    setRows((prevRows) =>
      prevRows.map((row, i) => {
        if (i !== rowIndex) return row;
        const currentValues = row[key] ? row[key].split(",") : [];
        const updatedValues = currentValues.includes(value)
          ? currentValues.filter((v) => v !== value)
          : [...currentValues, value];
        return { ...row, [key]: updatedValues.join(",") };
      }),
    );
  };

  const toggleDropdown = (rowIndex, dropdownKey, value) => {
    setDropdownStates((prevStates) =>
      prevStates.map((state, i) =>
        i === rowIndex ? { ...state, [dropdownKey]: value } : state,
      ),
    );
  };

  const setSearchQuery = (rowIndex, value, key) => {
    if (key === "PT_FROM") {
      setDropdownStates((prevStates) =>
        prevStates.map((state, i) =>
          i === rowIndex ? { ...state, fromStation: value } : state,
        ),
      );
    } else if (key === "PT_TO") {
      setDropdownStates((prevStates) =>
        prevStates.map((state, i) =>
          i === rowIndex ? { ...state, toStation: value } : state,
        ),
      );
    } else {
      setDropdownStates((prevStates) =>
        prevStates.map((state, i) =>
          i === rowIndex ? { ...state, ptTypeSearchQuery: value } : state,
        ),
      );
    }
  };

  const renderInput = (rowIndex, key) => {
    const row = rows[rowIndex];
    const dropdownState = dropdownStates[rowIndex] || {};

    switch (key) {
      case "PT_WASTAGE_NUM":
        return (
          <input
            type="number"
            className="form-control"
            value={row[key]}
            onChange={(e) => handleChange(rowIndex, key, e.target.value)}
          />
        );

      case "PT_TYPE": {
        const filteredTypeOptions = options.PT_TYPE.filter((opt) =>
          opt
            ?.toLowerCase()
            .includes((dropdownState.ptTypeSearchQuery || "").toLowerCase()),
        );

        return (
          <div className="dropdown" onClick={(e) => e.stopPropagation()}>
            <button
              className="btn btn-outline-secondary dropdown-toggle w-100 text-start"
              type="button"
              onClick={() =>
                toggleDropdown(
                  rowIndex,
                  "ptTypeDropdownOpen",
                  !dropdownState.ptTypeDropdownOpen,
                )
              }
            >
              <span
                className="d-inline-block text-truncate"
                style={{
                  maxWidth: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {row[key] && row[key].length > 0 ? row[key] : "Select types"}
              </span>
            </button>

            {dropdownState.ptTypeDropdownOpen && (
              <div
                className="dropdown-menu show w-100 p-2 border"
                style={{ maxHeight: "200px", overflowY: "auto" }}
              >
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="Search..."
                  value={dropdownState.ptTypeSearchQuery || ""}
                  onChange={(e) =>
                    setSearchQuery(rowIndex, e.target.value, "ptType")
                  }
                />
                {filteredTypeOptions.length > 0 ? (
                  filteredTypeOptions.map((opt, idx) => {
                    const selectedValues = row[key] ? row[key].split(",") : [];
                    const isChecked = selectedValues.includes(opt);

                    return (
                      <div className="form-check" key={idx}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`checkbox-${rowIndex}-${key}-${opt}`}
                          value={opt}
                          checked={isChecked}
                          onChange={() => toggleCheckbox(rowIndex, key, opt)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${rowIndex}-${key}-${opt}`}
                        >
                          {opt}
                        </label>
                      </div>
                    );
                  })
                ) : (
                  <div className="dropdown-item text-muted">No matches</div>
                )}
              </div>
            )}
          </div>
        );
      }

      case "PT_FROM":
      case "PT_TO": {
        const isDropdownOpen =
          key === "PT_FROM"
            ? dropdownState.ptFromDropdownOpen
            : dropdownState.ptToDropdownOpen;
        const toggleKey =
          key === "PT_FROM" ? "ptFromDropdownOpen" : "ptToDropdownOpen";
        const filteredFTOptions = options[key].filter((opt) =>
          opt
            ?.toLowerCase()
            .includes(
              (key === "PT_FROM"
                ? dropdownState.fromStation
                : dropdownState.toStation || ""
              )?.toLowerCase(),
            ),
        );

        return (
          <div className="dropdown" onClick={(e) => e.stopPropagation()}>
            <button
              className="btn btn-outline-secondary dropdown-toggle w-100 text-start"
              type="button"
              onClick={() =>
                toggleDropdown(rowIndex, toggleKey, !isDropdownOpen)
              }
            >
              <span
                className="d-inline-block text-truncate"
                style={{
                  maxWidth: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {row[key] && row[key].length > 0 ? row[key] : "Select options"}
              </span>
            </button>

            {isDropdownOpen && (
              <div className="dropdown-menu show p-2 border">
                <input
                  type="text"
                  className="form-control mb-2"
                  placeholder="Search From station..."
                  value={
                    key === "PT_FROM"
                      ? dropdownState.fromStation
                      : dropdownState.toStation || ""
                  }
                  onChange={(e) =>
                    setSearchQuery(rowIndex, e.target.value, key)
                  }
                />
                <div
                  style={{
                    maxHeight: "200px",
                    overflowY: "auto",
                    width: "170px",
                  }}
                >
                  {filteredFTOptions.length > 0 ? (
                    filteredFTOptions.map((opt, idx) => {
                      const selectedValues = row[key]
                        ? row[key].split(",")
                        : [];
                      const isChecked = selectedValues.includes(opt);

                      return (
                        <div className="form-check" key={idx}>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`checkbox-${rowIndex}-${key}-${opt}`}
                            value={opt}
                            checked={isChecked}
                            onChange={() => toggleCheckbox(rowIndex, key, opt)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`checkbox-${rowIndex}-${key}-${opt}`}
                          >
                            {opt}
                          </label>
                        </div>
                      );
                    })
                  ) : (
                    <div className="dropdown-item text-muted">No matches</div>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      }

      case "REMARK":
        return (
          <input
            type="text"
            className="form-control"
            value={row[key] || ""}
            onChange={(e) => handleChange(rowIndex, key, e.target.value)}
          />
        );

      case "PT_REASON":
      case "PT_WASTAGE_TRAIN_TYPE":
        return (
          <select
            className="form-control"
            value={row[key] || ""}
            onChange={(e) => handleChange(rowIndex, key, e.target.value)}
          >
            <option hidden value="">
              {row[key] || `Select ${key.replace("PT_", "").toLowerCase()}`}
            </option>
            {options[key].map((opt, idx) => (
              <option key={idx} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        );

      default:
        return null;
    }
  };

  const handleDelete = async (rowId) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this entry?",
    );
    if (!confirmed) return;

    setLoading(true);
    try {
      const response = await fetch(`${urlBlockPrefix}deletePathData/${rowId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      if (result.message === "path Data deleted successfully") {
        setResultMsg({ statusText: "ok", ...result });
        fetchData();
        setShow(true);
      } else if (result.message === "No Data Found with the given ID") {
        setResultMsg(result);
        setShow(true);
      }
      setLoading(false);
    } catch (err) {
      console.error("Error deleting data:", err);
      setResultMsg({ message: err.message || "Failed to delete data" });
      setShow(true);
      setLoading(false);
    }
  };

  const handleSubmit = async () => {
    const finalData = rows.map(
      ({ insert_time_stamp, updated_time_stamp, inserted_by, ...rest }) => ({
        ...rest,
        PT_DATE: selectedDate,
      }),
    );
    try {
      const response = await axios.put(
        `${urlBlockPrefix}updatePathData`,
        finalData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      // console.log(response);
      if (response.data.status === "ok") {
        setShow(true);
        setResultMsg({ ...response.data, statusText: "OK" });
      }
    } catch (err) {
      console.error("Update error:", err.response?.data || err);
      setResultMsg({ message: err.response?.data?.message || "Update failed" });
      setShow(true);
    }
  };

  return (
    <div
      onClick={() => {
        setDropdownStates((prevStates) =>
          prevStates.map((state) => ({
            ...state,
            ptTypeDropdownOpen: false,
            ptFromDropdownOpen: false,
            ptToDropdownOpen: false,
            ptTypeSearchQuery: "",
            ptFromSearchQuery: "",
            ptToSearchQuery: "",
            toStation: "",
            fromStation: "",
          })),
        );
      }}
    >
      <h5 className="bg-dark text-white text-center p-2">
        Insert Data In Path Wastage
      </h5>

      <div className="d-flex justify-content-center m-2">
        <input
          type="date"
          className="form-control"
          style={{ maxWidth: "200px" }}
          max={getCurrentDate()}
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
      </div>
      <div className="d-flex justify-content-center">
        <div style={{ overflowX: "auto" }}>
          <div style={{ width: "1550px", height: "500px" }}>
            <div className="border mb-3 papaDiv">
              <div className="d-flex mb-2 bg-dark">
                <div
                  className="bg-dark text-white text-center"
                  style={{ width: "50px", fontWeight: "bold", padding: "5px" }}
                >
                  Sr No.
                </div>
                {keys.map((key, idx) => (
                  <div
                    key={idx}
                    className="bg-dark text-white text-center"
                    style={{
                      width: "200px",
                      fontWeight: "bold",
                      textTransform: "capitalize",
                      padding: "5px",
                    }}
                  >
                    {key.replace("PT_", "").replace("_", " ")}
                  </div>
                ))}
                <div
                  className="bg-dark text-white text-center"
                  style={{ width: "50px", fontWeight: "bold", padding: "5px" }}
                >
                  Action
                </div>
              </div>

              {data.length > 0 ? (
                rows.map((row, rowIndex) => (
                  <div
                    key={rowIndex}
                    className="d-flex mb-2 align-items-center"
                  >
                    <div
                      className="text-center"
                      style={{ width: "50px", padding: "5px" }}
                    >
                      {rowIndex + 1}
                    </div>
                    {keys.map((key, idx) => (
                      <div key={idx} style={{ width: "200px", padding: "5px" }}>
                        {renderInput(rowIndex, key)}
                      </div>
                    ))}
                    <div
                      style={{ width: "50px", padding: "5px" }}
                      className="ms-4"
                    >
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => handleDelete(row.ID)}
                        title="Remove Row"
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                ))
              ) : (
                <NoDataFound />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="mb-3 text-center"></div>

      <div className="text-center mt-4">
        <button
          className="btn btn-outline-success m-2 px-5"
          onClick={handleSubmit}
        >
          Upload All
        </button>
      </div>
      <div className="p-3">
        {resultMsg && resultMsg.statusText === "OK" ? (
          <SuccessMsg
            head="Success"
            message={resultMsg.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          resultMsg && (
            <FailedMsg
              head="Failed"
              message={resultMsg.message || "Failed to complete the task"}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>
    </div>
  );
};

export default PathWastageUpdate;
